import React from 'react';
import FilterIcon, { FilterIconName } from './FilterIcon';

export interface FilterSectionProps {
  id: string;
  title: string;
  icon: FilterIconName;
  expanded: boolean;
  onToggle: () => void;
  summary?: React.ReactNode;
  summaryMuted?: boolean;
  summaryIsDateRange?: boolean;
  className?: string;
  children: React.ReactNode;
}

const FilterSection: React.FC<FilterSectionProps> = ({
  id,
  title,
  icon,
  expanded,
  onToggle,
  summary,
  summaryMuted,
  summaryIsDateRange,
  className,
  children,
}) => (
  <section className={`sf-section${className ? ` ${className}` : ''}`}>
    <button
      type="button"
      id={`sf-section-${id}`}
      className="sf-section__header"
      onClick={onToggle}
      aria-expanded={expanded}
      aria-controls={`sf-section-body-${id}`}
    >
      <span className="sf-section__icon" aria-hidden="true">
        <FilterIcon name={icon} size={16} />
      </span>
      <span className="sf-section__title">{title}</span>
      <span className={`sf-section__chevron ${expanded ? 'is-open' : ''}`} aria-hidden="true">
        <FilterIcon name="chevron-down" size={16} />
      </span>
      {summary ? (
        <span className="sf-section__summary">
          <span
            className={`sf-section__value ${summaryMuted ? 'sf-section__value--muted' : ''} ${
              summaryIsDateRange ? 'sf-section__value--dates' : ''
            }`}
            title={typeof summary === 'string' ? summary : undefined}
          >
            {summary}
          </span>
        </span>
      ) : null}
    </button>

    {expanded ? (
      <div id={`sf-section-body-${id}`} className="sf-section__body">
        {children}
      </div>
    ) : null}
  </section>
);

export default FilterSection;
